import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";
import { mergeMap, of } from "rxjs";
import { take } from "rxjs/operators";
import { PermissionService } from "../services/permission.service";
import { QUOTA_RELEVANT_ENDPOINTS } from "../../../shared/consts/quota-endpoints";

export const avmQuotaInterceptor: HttpInterceptorFn = (req, next) => {
  const permissionService = inject(PermissionService);
  const urlLower = req.url?.toLowerCase() ?? "";
  const isQuotaRelevant = QUOTA_RELEVANT_ENDPOINTS.some(endpoint => urlLower.includes(endpoint));

  return next(req).pipe(
    mergeMap(response => {
      if (isQuotaRelevant) {
        return permissionService.refreshQuota().pipe(
          take(1),
          mergeMap(() => of(response))
        );
      }
      return of(response);
    })
  );
};
